import axios from 'axios'
import Config from '@/config'
import { TOKEN_KEY } from '@/utils/constant'
import { Notification, Message } from 'element-ui'
import { iframePostMsg } from '../utils'

// 创建axios实例
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
axios.defaults.headers['authorization'] = 'uxAccessToken'
axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded;charset=UTF-8'
const service = axios.create({
  baseURL: Config.apiUrl,
  withCredentials: true,
  // 超时
  timeout: 1000 * 60 * 60 * 5
})
// request拦截器
service.interceptors.request.use(
  config => {
    // 是否需要设置 token
    // 让每个请求携带自定义token 请根据实际情况自行修改
    const isToken = (config.headers || {}).isToken === false
    if (window.sessionStorage.getItem(TOKEN_KEY) && !isToken) {
      config.headers[TOKEN_KEY] = window.sessionStorage.getItem(TOKEN_KEY) || ''
    }
    return config
  },
  error => {
    console.log(error)
    Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  res => {
    if (res.status === 200) {
      return res
    } else {
      Message.error(res.data.message || '网络异常')
      return Promise.reject(res)
    }
  },
  error => {
   console.log(error.response)
     //return Promise.reject(error)
     Message.error(error.response.data.message)
  }
)

export const get = (url, params = {}) => {

   return service.get(url, { params }).then(
      response => {
       return response.data
      })
}
export const post = (
  url,
  data
) => {
  return  service.post(url, data).then(response=>{
    return response.data
  })
}
export const upload = (url, file) => {
  const formData = new FormData()
  formData.append('file', file)
  return service.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
export const download = (url, data) => {
  return service({
    url: url,
    method: 'post',
    params: data,
    responseType: 'blob'
  })
}
export const downloadFile = response => {
  const blob = response.data
  const reader = new FileReader()
  reader.readAsDataURL(blob)
  reader.onload = e => {
    const a = document.createElement('a')
    a.style.display = 'none'
    a.download = 'fileName'
    a.href = e.target.result
    a.setAttribute('download', 'generator.zip')
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }
}

export default { service, upload, post, get, download }
